import { effect } from '@preact/signals'
import { api } from '../lib/api.ts'
import { url } from '@01edu/signal-router'

const verifyInvitation = api['GET/api/verify-invitation'].signal()
effect(() => {
  if (!url.params.tokeninvitation) return
  Promise.all([
    verifyInvitation.fetch({
      token: url.params.tokeninvitation,
    }),
    // we added a delay to avoid the page blinking too fast
    new Promise((resolve) => setTimeout(resolve, 500)),
  ]).then(() => {
    if (verifyInvitation.error) return
  })
})

export function VerifyInvitationPage() {
  const errorMessage =
    (verifyInvitation.error && verifyInvitation.error.message) ||
    (!url.params.tokeninvitation && 'Invalid invitation link (missing token)')
  return (
    <div class='min-h-screen flex items-center justify-center'>
      {errorMessage
        ? (
          <div class='text-center p-8 bg-base-500 border border-error rounded-box'>
            <h2 class='text-2xl font-bold mb-4 text-error'>Invitation Error</h2>
            <p>The invitation link is invalid or has expired.</p>
            {errorMessage && (
              <p class='text-sm mt-2 text-error'>{errorMessage}</p>
            )}
            <a href='/login' class='btn btn-primary mt-4'>
              Back to Login Page
            </a>
          </div>
        )
        : !verifyInvitation.data
        ? (
          <div class='text-center p-8 bg-base-500 border border-base-300 rounded-box'>
            <h2 class='text-2xl font-bold mb-4'>Verifying...</h2>
            <p>We're verifying your invitation link.</p>
            <div class='loading loading-spinner loading-lg mt-4' />
          </div>
        )
        : (
          <div class='text-center p-8 bg-base-500 border border-success rounded-box'>
            <h2 class='text-2xl font-bold mb-4 text-success'>
              Invitation Successful
            </h2>
            <p>You have been successfully invited.</p>
            <a href='/' class='btn btn-primary mt-4'>
              Continue to Dashboard
            </a>
          </div>
        )}
    </div>
  )
}
